var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pb-3"},[_c('VueEditor',{ref:_vm.textareaRefName,attrs:{"editorToolbar":_vm.customToolbar},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }